import { render } from "./StaticPageLayout.vue?vue&type=template&id=4f4300a8&scoped=true"
import script from "./StaticPageLayout.vue?vue&type=script&lang=js"
export * from "./StaticPageLayout.vue?vue&type=script&lang=js"

import "./StaticPageLayout.vue?vue&type=style&index=0&id=4f4300a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4300a8"]])

export default __exports__